module.exports = __webpack_public_path__ + "img/success@2x.fbc98347.png";